import { SvgIcon, useTheme } from "@mui/material";
import type React from "react";
import { useState } from "react";
import { tileTextStyle } from "./style.ts";

const Computers: React.FC<{ selected: boolean }> = ({ selected }) => {
	const [hovered, setHovered] = useState(false);
	const theme = useTheme();
	const idleBackground = theme.palette.secondary.main;
	const hoverBackground = theme.palette.secondary.light;
	const selectedBackGround = theme.palette.info.main;

	const backGroundColor = selected ? selectedBackGround : hovered ? hoverBackground : idleBackground;
	return (
		<SvgIcon
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			viewBox="0 0 460 259"
			sx={{ width: "100%", height: "auto" }}
		>
			<defs>
				<style>{".cls-2{fill:none;stroke:#fff; height: 100px;}"}</style>
			</defs>
			<g
				style={{
					fill: backGroundColor,
				}}
				id="Vrstva_2-2"
				data-name="Vrstva 2"
			>
				<rect className="cls-5" x="0" width="460" height="259" />
				<g>
					<path className="cls-2" d="M0,237.18c132.91-.24,273.64-.24,406.21,0" />
					<line className="cls-2" x1="460" y1="237.18" x2="405.06" y2="237.18" />
				</g>
			</g>
			<g id="Elektronika">
				<g>
					<path
						className="cls-2"
						d="M177,217.83h214.94v5.86c0,7.44-5.77,13.49-12.87,13.49h-189.21c-7.09,0-12.86-6.05-12.86-13.49v-5.86ZM391.94,223.7c0,7.44-5.77,13.49-12.87,13.49h-189.21c-7.09,0-12.86-6.05-12.86-13.49M383.3,197.56v-97.66c0-6.91-5.37-12.53-11.97-12.53h-173.72c-6.6,0-11.97,5.62-11.97,12.53v97.66c0,6.92,5.37,12.54,11.97,12.54h173.72c6.6,0,11.97-5.62,11.97-12.54Z"
					/>
					<rect className="cls-2" x="193.21" y="95.64" width="182.29" height="107.95" rx="4.51" ry="4.51" />
					<circle className="cls-3" cx="287.48" cy="92.36" r="1.17" />
				</g>
			</g>
			<text
				id="texty"
        style={tileTextStyle}
				transform="translate(20 44.289)"
			>
				Výpočetní technika
			</text>
		</SvgIcon>
	);
};

export default Computers;
